export default __webpack_public_path__ + "static/media/work1.bd7ff1f8.png";